(() => {
  if (window.sbxSuiteTilesReady) return;
  window.sbxSuiteTilesReady = true;
  let navigationTimer = null;
  let activeTile = null;
  const clearNavigation = () => {
    window.clearTimeout(navigationTimer);
    navigationTimer = null;
    activeTile?.classList.remove('is-illuminated');
    activeTile = null;
  };
  document.addEventListener('click', (event) => {
    const tile = event.target.closest?.('a.sbx-plaque');
    if (!tile || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || tile.hasAttribute('download') || (tile.target && tile.target !== '_self')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    clearNavigation();
    activeTile = tile;
    tile.classList.add('is-illuminated');
    navigationTimer = window.setTimeout(() => {
      clearNavigation();
      window.location.assign(tile.href);
    }, 180);
  });
  window.addEventListener('pagehide', clearNavigation);
  window.addEventListener('pageshow', () => {
    clearNavigation();
    document.querySelectorAll('.sbx-plaque.is-illuminated').forEach((tile) => tile.classList.remove('is-illuminated'));
  });
})();
